module.exports = __webpack_public_path__ + "img/paat_kolmnurk.f13cee16.png";